import { configureStore } from "@reduxjs/toolkit";
import themeReducer from "../redux/reduser/theme";
import usersReducer from "../redux/reduser/users";
import loginReducer from "../redux/reduser/login";

import addNewAdminReducer from "./reduser/addNewAdmin";

import editProfileReducer from "./reduser/editProfile";
import changePasswordReducer from "./reduser/changePassword";
import notificationsReducer from "./reduser/notifications";
import productsReducer from './reduser/products';

import ordersReducer from "./reduser/orders";
import administratorsReducer from "./reduser/administrators";
import editProductReducer from "./reduser/editProduct";
import addProductReducer from "./reduser/addProduct";
import categoriesReducer from "./reduser/categories";
import editCategoryReducer from "./reduser/editCategory";
import addCategoryReducer from "./reduser/addCategory";
import invoicesReducer from "./reduser/invoices";
import salesReducer from "./reduser/sales";
const store = configureStore({
  reducer: {
    theme: themeReducer,
    users: usersReducer,
    login: loginReducer,

    addNewAdmin: addNewAdminReducer,

    editProfile: editProfileReducer,
    changePassword: changePasswordReducer,
    notifications: notificationsReducer,
    products:productsReducer,

    orders: ordersReducer,
    administrators:administratorsReducer,
    addProduct:addProductReducer,
    editProduct:editProductReducer,
    categories:categoriesReducer,
    addCategory:addCategoryReducer,
    editCategory:editCategoryReducer,
    invoices:invoicesReducer,
    sales:salesReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: true,
    }),
});
export default store;
